import { apiClient } from './api.client';

export interface CameraNotificationRule {
  id?: string;
  name: string;
  enabled: boolean;
  event_types: string[];
  min_count: number;
  window_seconds: number;
  cooldown_seconds: number;
}

export interface CameraNotificationSettings {
  enabled: boolean;
  rules: CameraNotificationRule[];
}

export interface CompanyEmailSettings {
  enabled: boolean;
  smtp_host: string;
  smtp_port: number;
  security: 'starttls' | 'ssl';
  username: string;
  password?: string;
  clear_password?: boolean;
  password_configured?: boolean;
  from_email: string;
  from_name: string;
  recipients: string[];
  recent_deliveries?: { id: string; email_status: string; email_error?: string; created_at: string }[];
}

export interface EventVideoJob {
  event_id: number;
  video_status: 'pending' | 'collecting' | 'waiting' | 'publishing' | 'published' | 'processing' | 'completed' | 'failed' | 'skipped' | 'not_scheduled';
  attempts: number;
  next_attempt_at?: string;
  last_error?: string;
  snapshot_status?: 'pending' | 'waiting' | 'processing' | 'completed' | 'failed' | 'skipped' | 'not_scheduled';
  snapshot_error?: string;
  snapshot_url?: string | null;
  thumbnail_url?: string | null;
  video_url?: string | null;
}

export const eventProcessingService = {
  getCameraSettings: (id: number) => apiClient.get<CameraNotificationSettings>(`/camera-security/camera/${id}/notification-settings`),
  saveCameraSettings: (id: number, settings: CameraNotificationSettings) => apiClient.put<CameraNotificationSettings>(`/camera-security/camera/${id}/notification-settings`, settings),
  getEmailSettings: () => apiClient.get<CompanyEmailSettings>('/configuration/notification-email'),
  saveEmailSettings: (settings: CompanyEmailSettings) => apiClient.put<CompanyEmailSettings>('/configuration/notification-email', settings),
  testEmail: () => apiClient.post<{ id: string; status: string; message: string }>('/configuration/notification-email/test', {}),
  getVideoJob: (id: number) => apiClient.get<EventVideoJob>(`/camera-security/event-processing/jobs/${id}`),
  queueVideoJob: (id: number) => apiClient.post(`/camera-security/event-processing/jobs/${id}/queue`, {}),
  retryVideoJob: (id: number) => apiClient.post(`/camera-security/event-processing/jobs/${id}/retry`, {}),
};

export function processingError(error: unknown): string {
  const detail = (error as any)?.response?.data?.detail;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) return detail.map(item => item.msg).join('. ');
  return error instanceof Error ? error.message : 'Unable to save settings';
}
